import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  font-family: "Open Sans", "sans-serif";
`;

export const StoreInfoWrapper = styled.div`
  .title {
    display: table;
    width: 100%;
    background-color: rgb(76, 76, 76);
  }

  .store-name,
  .title-text {
    margin: 0;
    text-transform: uppercase;
    font-weight: 800;
    color: white;
    font-size: 2rem;
    line-height: 1.1;
    padding: 15px;
  }

  .store-village {
    margin: 0;
    text-transform: uppercase;
    font-weight: 400;
    color: white;
    padding: 0 15px 15px 15px;
  }

  .store-address {
    background-color: #bdb1c5;
    display: inline-block;
    min-width: 30%;
    max-width: 50%;
    padding: 15px;
    color: white;
    font-size: 15px;
  }

  .short-description {
    font-size: 16px;
    font-weight: 400;
    line-height: 1.428;
//   }

  // text inside accordion
  .ant-collapse > .ant-collapse-item > .ant-collapse-header {
    color: #fff;
  }
`;

export const ItemInfoWrapper = styled.div`
  // margin: 0 auto;
  font-family: "Open Sans", "sans-serif";
  padding-bottom: 10px;
  margin-top: -20px;

  .title {
    display: table;
    width: 100%;
    background-color: rgb(76, 76, 76);
  }

  .item-name {
    margin: 0;
    text-transform: uppercase;
    font-weight: 600;
    color: white;
    font-size: 34px;
    line-height: 1.1;
    padding: 15px 15px 15px 15px;
  }

  .item-parent {
    margin: 0;
    text-transform: uppercase;
    font-weight: 200;
    color: white;
    padding: 0 15px 15px 15px;
  }

  .description {
    font-family: "Open Sans", "sans-serif";
    font-size: 14px;
    font-weight: 400;
    line-height: 1.428;
  }

  .carousel-container {
    width: 100%;
    // margin: 20px auto;
  }

  .ant-image-img {
    object-fit: cover;
    max-width: 100%;
    max-height: 400px;
    width: auto;
    height: auto;
  }

  .ahp-added-to-cart {
    display: block;
    font-size: 1rem;
    color: white;
    font-weight: 600px;
    padding: 16px;
    background-color: green;
    text-transform: uppercase;
  }

  .add-to-cart-dialog-content {
    width: 90%;
    margin: 0 auto;
  }
`;
